module.exports = __webpack_public_path__ + "static/img/pull-icon-quer.0b9ca0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pull-icon-quer.png
// module id = yNFi
// module chunks = 208